import { render, staticRenderFns } from "./paycenter.vue?vue&type=template&id=0c67ec5a&scoped=true&"
import script from "./paycenter.vue?vue&type=script&lang=js&"
export * from "./paycenter.vue?vue&type=script&lang=js&"
import style0 from "./paycenter.vue?vue&type=style&index=0&id=0c67ec5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c67ec5a",
  null
  
)

export default component.exports